import React from 'react'
import Temperatur from '../../../components/Sensor/Temperatur'
import Speedometer from '../../../components/Sensor/Speedometer'
import { HiLightningBolt } from 'react-icons/hi'

const Engine1 = ({ dataSource }) => {

    const [dataTemperatur] = dataSource.items.filter((item) =>
        item.SensorCode.startsWith("TMP")
    );
    const [dataSpeedoMeter] = dataSource.items.filter((item) =>
        item.SensorCode.startsWith("RPM")
    );

    return (

        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-lg border border-white/20 p-6">
            <div className="flex items-center space-x-3 mb-4">
                <div className="w-8 h-8 bg-red-500/20 rounded-lg flex items-center justify-center">
                    <HiLightningBolt className="w-4 h-4 text-red-600" />
                </div>
                <div>
                    <h3 className="text-lg font-semibold text-gray-900">{dataSource.groupName}</h3>
                    <p className="text-sm text-gray-600">RPM and Temperature monitoring</p>
                </div>
            </div>

            <div className="flex flex-col w-full rounded gap-2 bg-white p-4">
                <div className="flex flex-col lg:flex-row justify-evenly gap-6">
                    <Temperatur dataSource={dataTemperatur} />
                    <Speedometer dataSource={dataSpeedoMeter} />
                </div>
            </div>

        </div>
    )
}

export default Engine1